import { useSelector } from "react-redux";

export type Place360AuthUser = {
  id: string;
  role: "admin" | "user";
};

/**
 * Maps Redux auth user into the shape expected by Omni Watch–style components.
 */
export function useAuth(): { user: Place360AuthUser | null } {
  const raw = useSelector(
    (state: {
      auth?: {
        user?: Record<string, unknown> | null;
        accountAccess?: { isAdmin?: boolean; userId?: string } | null;
      };
    }) => state.auth?.user ?? null,
  );
  const accountAccess = useSelector(
    (state: { auth?: { accountAccess?: { isAdmin?: boolean; userId?: string } | null } }) =>
      state.auth?.accountAccess ?? null,
  );
  if (!raw) return { user: null };
  const id = String(
    accountAccess?.userId ?? raw.id ?? raw.user_id ?? raw.email ?? "user",
  ).trim();
  const isAdmin = Boolean(
    accountAccess?.isAdmin ||
      String(raw.role ?? raw.user_type ?? raw.userType ?? "")
        .toLowerCase()
        .trim() === "admin" ||
      raw.is_admin === true ||
      raw.isAdmin === true,
  );
  return {
    user: {
      id: id || "user",
      role: isAdmin ? "admin" : "user",
    },
  };
}
